export default __webpack_public_path__ + "static/chess--mobile-f4d1ecaa8d08ea347fead33288049e8c.jpg";